import styled from 'styled-components';

export const BannerContainer = styled.div`
  display: flex;
  flex-direction: column;

  background-color: #000;
`;

export const BannerImage = styled.img`
  width: 100%;
  height: auto;
`;

/** Mirrors the source's `a-col :xs="24" :lg="is_webview ? 24 : 14"` + `margin: auto`. */
export const BannerContent = styled.div<{ $fullWidth?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 10px;

  width: 100%;
  margin: auto;
  padding: 0 0 30px;

  @media only screen and (min-width: 1024px) {
    gap: 20px;

    width: ${(props) => (props.$fullWidth ? '100%' : '58.333333%')};
    padding: 20px 0 40px;
  }

  h4,
  p {
    color: #fff;
    text-align: center;
  }

  h4 {
    font-weight: 700;
    font-size: 24px;
    margin: 0;
  }

  p {
    font-weight: 500;
    font-size: 14px;
    margin: 0;
  }
`;
